import { render, staticRenderFns } from "./lkuBankaccount.vue?vue&type=template&id=da533ff4&"
import script from "./lkuBankaccount.vue?vue&type=script&lang=js&"
export * from "./lkuBankaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports